import React from 'react';
import {useSelector} from 'react-redux';
import {View} from 'react-native';
import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';
///////////////////////////
// components /////////////
import {ContinueButton, BodyText, TextLine} from 'src/Modules/CommonView';
import {Image} from 'react-native';
import {Alert} from 'react-native';

import {navigationRef} from 'src/Nav/navigationHelpers';
import {setDataAtPath, updateDataAtPath} from 'src/Utils/fireUtils';
import {mmkvStorage} from '../Utils/mmkvStorage';

const JoinVoucherSearch = ({
  background = global?.color?.white1,
  handlePress = () => null,
}) => {
  const {width} = useWindowDimensionsSafe();

  const ticket_vouchers = useSelector((state) => state.ticket_vouchers);

  const deleteAllTickets = async (handleDone) => {
    if (!__DEV__) {
      return console.log('forbidden');
    }

    const {allVouchers = []} = ticket_vouchers;
    allVouchers?.map?.((voucher) => {
      const {voucherCode = 'error'} = voucher || {};
      if (voucherCode) {
        console.log('deleting', {voucherCode});
        setDataAtPath(
          `transactions/purchases/${voucherCode || 'error'}/`,
          null,
        );
      }
    });
    handleDone();
  };

  const unRedeemAllTickets = async (handleDone) => {
    if (!__DEV__) {
      return console.log('forbidden');
    }
    const {allVouchers = []} = ticket_vouchers;
    mmkvStorage.set('seenVouchers', '');
    allVouchers?.map?.((voucher) => {
      const {voucherCode = 'error'} = voucher || {};
      if (voucherCode) {
        console.log('undreeming', {voucherCode});
        updateDataAtPath(`transactions/purchases/${voucherCode || 'error'}/`, {
          redeemed: null,
          redeemedAt: null,
          redeemedDate: null,
          proccessedRedemptions: null,
          previously_redeemed: null,
          redeemingUserId: null,
          askedToRedeem: null,
        });
      }
    });
    handleDone();
  };

  var {allVouchers = []} = ticket_vouchers;
  // removing notifications used for gifts
  allVouchers = allVouchers.filter((voucher) => {
    return voucher.type !== 'notification';
  });
  // console.log({allVouchers});
  if (!allVouchers?.[0]) {
    return <View>{/* <BodyText text={'hi'} /> */}</View>;
  }

  if (window?.location?.href?.includes?.('isDemo')) {
    return;
  }

  return (
    <View
      style={{
        flex: 1,
        paddingTop: 5,
        display: 'flex',
        alignItems: 'center',
      }}>
      <TextLine text={'OR'} containerStyle={{marginTop: 10, minWidth: 110}} />
      <BodyText
        text={
          'Use tickets already found in your account. These are linked by your email/phone number.'
        }
        textStyle={{
          marginBottom: 0,
          textAlign: 'center',
          flex: 1,
          padding: 20,
        }}
      />
      {__DEV__ && !!allVouchers && (
        <ContinueButton
          text={'Delete All My Tickets'}
          containerStyle={{width: 300}}
          handlePress={() => {
            navigationRef.navigate('ConfirmModal', {
              handleConfirm: async (handleDone) => {
                deleteAllTickets(handleDone);
              },
              confirmText: 'Delete All My Tickets',
              confirmColor: global?.color?.orange,
              cancelText: 'Cancel',

              titleText: 'Are you sure? ',
              titleBodyText:
                'For the best scavenger hunt experience, we recommend that you play on multiple devices. That way each player gets to compete to answer location challenges.',
            });
          }}
        />
      )}
      {__DEV__ && !!allVouchers && (
        <ContinueButton
          text={'Unredeem All My Tickets'}
          containerStyle={{width: 300}}
          handlePress={() => {
            navigationRef.navigate('ConfirmModal', {
              handleConfirm: async (handleDone) => {
                unRedeemAllTickets(handleDone);
              },
              confirmText: 'Unreddem All My Tickets',
              confirmColor: global?.color?.teal,
              cancelText: 'Cancel',

              titleText: 'Are you sure? ',
              titleBodyText:
                'For the best scavenger hunt experience, we recommend that you play on multiple devices. That way each player gets to compete to answer location challenges.',
            });
          }}
        />
      )}
      {allVouchers
        ?.sort?.((a, b) => {
          if (!!a?.redeemed == !!b?.redeemed) {
            return a?.voucherCode > b?.voucherCode ? 1 : -1;
          }
          return !!a?.redeemed > !!b?.redeemed ? 1 : -1;
        })
        ?.map?.((item) => {
          const {type = 'ticket', subType = 'groupon', purchase = {}} = item;
          const {tickets = 2} = purchase;
          if (tickets < 1) {
            return;
          }
          return (
            <View
              key={item?.voucherCode}
              style={{
                width: width - 40,

                borderWidth: 1,
                borderColor: global.color.gray3,
                borderRadius: 10,
                marginBottom: 10,
                marginTop: 10,
                backgroundColor: background,
              }}>
              <BodyText
                text={`Found ${
                  type == 'third_party' ? 'Third-Party Voucher' : 'Voucher'
                }: ${item?.voucherCode?.toUpperCase?.()}`}
                textStyle={{
                  textAlign: 'center',
                  width: '100%',
                  fontWeight: 'bold',
                  fontSize: 20,
                  lineHeight: 20,
                  marginTop: 16,
                }}
              />
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  padding: 20,
                }}>
                <View>
                  <Image
                    style={{width: 50, height: 50}}
                    source={require('src/Images/standardTicketIcon.png')}
                  />
                </View>
                <View style={{flex: 1}}>
                  <BodyText text={`Tickets: ${item?.purchase?.tickets}`} />
                  <BodyText
                    text={
                      item?.pass ? 'Season Pass' : `${item?.purchase?.theme}`
                    }
                  />
                </View>
                <View style={{width: 120}}>
                  <ContinueButton
                    text={
                      !!item?.redeemed
                        ? ' Redeemed'
                        : type == 'third_party'
                        ? 'Go To'
                        : 'Redeem'
                    }
                    background={
                      !!item?.redeemed ? 'white' : global?.color?.blue
                    }
                    handlePress={() => {
                      if (!!item?.redeemed) {
                        return Alert.alert('Already Redeemed');
                      }
                      if (type == 'third_party') {
                        return navigationRef.navigate('GrouponRedemption', {
                          voucherCode: item?.voucherCode,
                          autoFound: true,
                          subType: subType,
                          ticketsQuantity: tickets,
                          voucherSource: subType,
                        });
                      }
                      handlePress(item?.voucherCode, item);
                    }}
                    textStyle={{
                      color: !!item?.redeemed ? 'black' : 'white',
                    }}
                    containerStyle={{
                      width: 60,
                      minWidth: 100,
                      background: 'red',
                      padding: 0,
                    }}
                  />
                </View>
              </View>
            </View>
          );
        })}
    </View>
  );
};

export default JoinVoucherSearch;
